import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DocumentViewerComponent } from './document-viewer.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { PDFViewerModule } from '@progress/kendo-angular-pdfviewer';

@NgModule({
  declarations: [DocumentViewerComponent],
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    ButtonModule,
    ButtonsModule,
    PDFViewerModule,
    InputsModule,
    FormsModule
  ],
  exports: [DocumentViewerComponent],
})
export class DocumentViewerModule { }
